import React from "react";
import { Button, FormControl, TextField, Typography } from "@mui/material";
import { notification } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import Store from "_Store";
import Container from "../../components/Layout/Container";
import BgAuth from "../../assets/img/bg-auth.png";
import { useNavigate, Link } from "react-router-dom";
import { forgotPassword } from "../../services/auth.service";
import { getFarms } from "services/farm.service";

export default function ForgotPassword() {
  const { setUtils } = React.useContext(Store);
  const navigate = useNavigate();
  const [error, setError] = React.useState("");

  const validationSchema = yup.object({
    userId: yup.string().required("Non valide, réessayer"),
    resetCodeBy: yup.string().required("Email or SMS?"),
  });
  const formik = useFormik({
    initialValues: {
      userId: "",
      resetCodeBy: "email",
    },
    validationSchema,
    onSubmit: (v) => {
      setError("");
      console.log(v)
      setUtils("loading", { spinning: true, primary: "" });

      forgotPassword(v)
        .then((res) => res.data)
        .then((res) => {
          if (res.success) {
            // TODO: should get token or user info returned from request
            // getFarms(v.userId).then((res) => {
            //   console.log(res.data);
            // })

            navigate("/otp", {state : v});
            setUtils("loading", { spinning: false, primary: "" });
          } else {
            setError(
              "Identifiant ou mot de passe non valide. Veuillez réessayer !"
            );
            setUtils("loading", { spinning: false, primary: "" });
          }
        })
        .catch((err) => {
          // console.log(err);
          setError(
            "Identifiant ou mot de passe non valide. Veuillez réessayer !"
          );
          setUtils("loading", { spinning: false, primary: "" });
        });
    },
  });

  return (
    <Container>
      <div className="flex-1 flex pt-12 sm:pt-36">
        <div className="w-full flex justify-center px-4">
          <div className="max-w-[490px] w-full">
            <div className="mb-6">
              <Typography variant="formTitle">
                Besoin d’aide pour votre mot de passe ?
              </Typography>
            </div>

            {error !== "" ? (
              <Typography color={"red"} fontSize={14} pb={4}>
                {error}
              </Typography>
            ) : null}

            <div>
              <form onSubmit={formik.handleSubmit}>
                <div className="mb-9">
                  <FormControl fullWidth>
                    <TextField
                      size="large"
                      name="userId"
                      label="Saisissez votre identifiant de connexion (num NIP, CNI…)"
                      type="text"
                      value={formik.values.userId || ""}
                      error={
                        formik.touched.userId && Boolean(formik.errors.userId)
                      }
                      helperText={formik.touched.userId && formik.errors.userId}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>

                <div>
                  <Typography>
                    Recevez un code de réinitialisation de mot de passe par
                  </Typography>
                  <div className="flex space-x-4 mt-2">
                    <div className="flex-1">
                      <Button
                        size="medium"
                        variant={formik.values.resetCodeBy === 'email' ? "contained" : 'outlined'}
                        disableElevation
                        color="success"
                        type="button"
                        fullWidth
                        onClick={() =>
                          formik.setFieldValue("resetCodeBy", "email")
                        }
                      >
                        Email
                      </Button>
                    </div>

                    <div className="flex-1">
                      <Button
                        size="medium"
                        variant={formik.values.resetCodeBy === 'sms' ? "contained" : 'outlined'}
                        disableElevation
                        color="success"
                        type="button"
                        fullWidth
                        onClick={() =>
                          formik.setFieldValue("resetCodeBy", "sms")
                        }
                      >
                        SMS
                      </Button>
                    </div>

                  </div>
                </div>

                <div>
                  {formik.values.resetCodeBy !== "" &&
                    formik.errors.resetCodeBy}
                </div>

                <div className="mt-12">
                  <Button
                    size="large"
                    variant="contained"
                    disableElevation
                    color="success"
                    type="submit"
                  >
                    Recevoir le code
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="sm:w-5/12 bg-cover"
        style={{ backgroundImage: `url(${BgAuth})` }}
      ></div>
    </Container>
  );
}
